import React, { useContext } from 'react';
import { Favorite } from '@thd-olt-component-react/save-to-favorites';
import { StickyContext } from '@thd-olt-component-react/sticky';
import {
  bool, number, string
} from 'prop-types';

export const BuyboxSaveToFavorites = ({ quantity, itemId, isStickyChild }) => {
  const { isVisible } = useContext(StickyContext);

  return (
    <Favorite
      itemId={itemId}
      label="Add To List"
      showAddToListBox
      closeTooltip={!isVisible && isStickyChild}
      quantity={quantity}
    />
  );
};

BuyboxSaveToFavorites.defaultProps = {
  quantity: 1,
  isStickyChild: false
};

BuyboxSaveToFavorites.propTypes = {
  quantity: number,
  itemId: string.isRequired,
  isStickyChild: bool
};